<template>
  <div class="question-container" style="border: 1px solid #edeff2">
    <div class="question-type">自定义</div>
    <div class="title-view">
      <!-- <p style="color: #4c4a56">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span>
        {{ `${dataObj.questionIndex ? dataObj.questionIndex : index + 1}、`
        }}{{ dataObj.caseProblem }}
      </p> -->

      <p style="color: #4c4a56">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span>
        {{ `${dataObj.questionIndex ? dataObj.questionIndex : index + 1}、` }}
        <span style="color: #4c4a56">{{ dataObj.caseProblem }}</span>
      </p>
    </div>

    <div class="question-images">
      <div
        v-for="(item, idx) in images"
        :key="idx"
        style="margin-top: 10px; position: relative"
      >
        <img :src="item" style="width: 100%" />
      </div>
    </div>

    <el-input
      v-if="operate === 'answer'"
      placeholder="请输入"
      resize="none"
      v-model="context"
      @blur="handleInputBlur"
    >
    </el-input>
    <div v-else class="select-view">
      <p style="font-size: 28rpx; color: #2b2f36; word-break: break-all">
        {{ context || "请输入" }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: {},
    },
    operate: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dataObj: {},
      index: 0,
      images: [],
      answerText: "",
      context: "",
    };
  },
  methods: {
    handleInputBlur(e) {
      console.log(e.target.value, "e.target.value");
      this.context = e.target.value;
      this.dataObj.context = e.target.value;
      this.answerObj = {
        question_id: this.dataObj.id,
        type: this.dataObj.type,
        if_hide: this.dataObj.if_hide,
        answer: [
          {
            id: "",
            context: e.target.value,
          },
        ],
      };
      this.$emit(
        "update",
        JSON.stringify({
          data: this.dataObj,
          answer: this.answerObj,
          index: this.index,
        }),
      );
    },
  },
  watch: {
    params: {
      handler(newVal) {
        console.log(newVal, "qweqeh1et12e12yef12ef12ye12");
        this.dataObj = newVal.data;
        this.index = newVal.index;
        this.images = JSON.parse(newVal.data.caseProblemImg || "[]");
        this.context = newVal.data.context || "";

        // if (
        //   newVal.answer &&
        //   Array.isArray(newVal.answer.answer) &&
        //   newVal.answer.answer.length > 0
        // ) {
        //   this.answerText = newVal.answer.answer[0].context || "";
        // } else {
        //   this.answerText = "";
        // }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.select-view {
  width: 100%;
  min-height: 44px;
  background-color: #f9f9f9;
  border-radius: 3px;
  margin-top: 12px;
  padding: 0 12px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #ededed;
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionPreview/QuestionPreviewCustomize.vue